import { Component } from '@angular/core';
import { HeaderBaseComponent } from '../../header.base-component';

@Component({
  selector: 'default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
})
export class DefaultHeaderComponent extends HeaderBaseComponent {}
